const preventImageCache = (url: string) => {
  if (!url) return undefined
  return `${url}?t=${new Date(Date.now()).setSeconds(0, 0)}`
}

export default preventImageCache
